import loadable from '@loadable/component';
import Loading from '../../../components/Loader';
import {
  fetchTopicLetterCounts,
  fetchFeaturedTopics,
  fetchTopicsByLetter
} from '../../../actions/topic';

const Topics = loadable(() => import(/* webpackChunkName: "topics" */ './Container'), {
  fallback: Loading
});

Topics.needs = (props, { dispatch }) => {
  const { letter } = props.params;
  const fetchTopics = letter
    ? dispatch(fetchTopicsByLetter(letter))
    : dispatch(fetchFeaturedTopics());
  return Promise.all([dispatch(fetchTopicLetterCounts(), fetchTopics)]);
};
export default Topics;
